import React, {useCallback, useMemo} from 'react';
import './DocketSelect.less';
import Select from "../Select/Select";
import {connect} from "react-redux";
import type {RootState} from "../../@types/store";
import type {uuid} from "../../@types/entity";

function DocketSelect(props: DocketSelectProps) {
    const dockets = useMemo(() => props.dockets
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(d => {
                let label = d.name;
                if (d.courtId && props.courts) {
                    const court = props.courts.get(d.courtId);
                    if (court && court.status !== 'D' && court.name) {
                        label = `${d.name} — ${court.name}`;
                    }
                }
                return {
                    label,
                    value: d.id
                }
            })
        , [props.dockets, props.courts]);


    /**
     * @param {uuid} docketId
     */
    const onChange = useCallback((docketId: uuid) => {
        if (!docketId) props.onChange(null);
        else {
            props.onChange(docketId);
        }
    }, [props]);

    /**
     *
     * @param {uuid} [docketId]
     */
    const getDockets = useCallback((docketId: uuid) => {
        return dockets.find(o => o.value === docketId);
    }, [dockets]);

    return <Select name='docketSelect'
                   clsName='docket-select'
                   allowNone={props.allowNone ?? true}
                   autoAdvance={props.autoAdvance}
                   defaultValue={getDockets(props.defaultValue)}
                   isMulti={false}
                   disabled={props.disabled}
                   options={dockets}
                   onChange={onChange}
                   tabSelectsValue={true}
                   usesExtraFields={false}
                   placeholder={props.placeholder || ''}
                   disablePortaling={props.disablePortaling}
    />;
}

export type DocketSelectProps = Pick<RootState, 'dockets' | 'courts'> & {
    // Should we allow empty choices? Realistically, this just determines if we have a clear button
    allowNone?: boolean,

    // After a single-select value is picked, advance focus to the next form field
    autoAdvance?: boolean,

    // The default value.  Array if isMulti is true.
    defaultValue?: uuid,

    // Pass-through
    disabled?: boolean,

    // Should we disable portaling?
    disablePortaling?: boolean,

    // Called when the client changes.  Sends back a Contact object.
    onChange: (docketId: uuid | null) => void,

    // Placeholder text
    placeholder?: string,
};

const mapStateToProps = (state: RootState) => {
    return {
        dockets: state.dockets,
        courts: state.courts
    };
};

export default connect(mapStateToProps, null)(DocketSelect);
